/**
 * Sticky bottom navigation for mobile screens.
 * Renders role-appropriate nav items (student or teacher).
 * Hidden on desktop via CSS (.mobile-nav { display: none } above 640px).
 */
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../stores/auth';

export function MobileNav() {
  const { user } = useAuth();
  const { pathname } = useLocation();

  if (!user) return null;

  if (user.role === 'admin') {
    return (
      <nav className="mobile-nav" aria-label="메인 메뉴">
        <Link
          to="/teacher"
          className={pathname === '/teacher' ? 'active' : ''}
        >
          <span className="nav-icon" aria-hidden="true">&#9633;</span>
          Dashboard
        </Link>
        <Link
          to="/teacher/students"
          className={pathname === '/teacher/students' ? 'active' : ''}
        >
          <span className="nav-icon" aria-hidden="true">&#9826;</span>
          Students
        </Link>
        <Link
          to="/teacher/problems"
          className={pathname === '/teacher/problems' ? 'active' : ''}
        >
          <span className="nav-icon" aria-hidden="true">&#9998;</span>
          Problems
        </Link>
      </nav>
    );
  }

  return (
    <nav className="mobile-nav" aria-label="메인 메뉴">
      <Link
        to="/student"
        className={pathname === '/student' ? 'active' : ''}
      >
        <span className="nav-icon" aria-hidden="true">&#9633;</span>
        Home
      </Link>
    </nav>
  );
}
